import React from 'react'
import { useState, useEffect } from 'react'
import { Table } from 'antd'
import { TableWrapper } from './style'

const MainTable = (props) => {
  const [propsT, setPropsT] = useState(null);
  useEffect(() => {
    var temp = { ...props }
    if (temp !== null && temp.columns !== undefined && temp.columns != null) {
      temp.columns.forEach(element => {

        switch (element.key) {
          case "psName":
            element.width = element.width || 198;
            break;
          case "deviceName":
            element.width = element.width || 168;
            break;
          case "deviceTypeId":
            element.width = element.width || 138;
            break;
          case "maskNo":
            element.width = element.width || 88;
            break;
          case "opera":
            element.width = element.width || 118;
            element.align = element.align || 'right';
            break;
          case "maskCount":
            element.width = element.width || 88;
            element.align = element.align || 'center';
            break;
          case "getdatetime":
            element.width = element.width || 138;
            element.align = element.align || 'right';
            break;
          case "beginTime":
            element.width = element.width || 138;
            element.align = element.align || 'right';
            break;
          case "endTime":
            element.width = element.width || 138;
            element.align = element.align || 'right';
            break;
          case "lastTime":
            element.width = element.width || 138;
            element.align = element.align || 'right';
            break;
          case "deviceAddress":
            element.width = element.width || 138;
            element.align = element.align || 'center';
            break;
          default:
            break;
        }

      });
    }
    setPropsT(temp)
  }, [props])//eslint-disable-line

  //if(temp.co)

  return (
    <>
      <TableWrapper key={props.key}>
        <Table {...props} />
      </TableWrapper>
    </>
  )
}

export { MainTable }